'use client'

import type { ReactNode } from 'react'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import { CapsuleBannerType } from 'services/graphql/contentStack/homes/query.type'
import { BannerFullHeightWrapper } from '../../Shared/BannerFullHeightWrapper/BannerFullHeightWrapper'

interface CapsuleWrapperProps {
	readonly children: ReactNode
	readonly type: CapsuleBannerType
}

export function CapsuleWrapper({
	children,
	type,
}: CapsuleWrapperProps): ReactNode {
	const { isSmall } = useResponsive()

	if (type === CapsuleBannerType.Moments && isSmall) {
		return children
	}
	return <BannerFullHeightWrapper>{children}</BannerFullHeightWrapper>
}
